import http from "./http";
export const baseUrl = "/v2/api/app";
export const baseUrl2 = "/v2/api/platform";

const { get, post } = http;
const getAtomicPage = (params: any) => post(`${baseUrl}/atomic/page`, params); // 查询原子化列表
const getAppPage = (params: any) => post(`${baseUrl}/app/page`, params); // 查询应用列表
const getEnginePage = (params: any) => post(`${baseUrl}/engine/page`, params); // 查询开鸿应用引擎列表
const getAcsPage = (params: any) => post(`${baseUrl}/acs/page`, params); // 查询安卓生态应用列表
const getComponentPage = (params: any) => post(`${baseUrl}/component/page`, params); // 查询组件列表
const atomicRepeatName = (params: any) => post(`${baseUrl}/atomic/name/exist`, params); // 检查原子化名称是否存在,存在时返回true,不存在时返回false
const appRepeatName = (params: any) => post(`${baseUrl}/app/name/exist`, params); // 检查应用名称是否存在,存在时返回true,不存在时返回false
const engineRepeatName = (params: any) => post(`${baseUrl}/engine/name/exist`, params); // 检查开鸿应用引擎名称是否存在,存在时返回true,不存在时返回false
const acsRepeatName = (params: any) => post(`${baseUrl}/acs/name/exist`, params); // 检查安卓生态应用名称是否存在,存在时返回true,不存在时返回false
const componentRepeatName = (params: any) => post(`${baseUrl}/component/name/exist`, params); // 检查组件名称是否存在,存在时返回true,不存在时返回false
const atomicRepeatPackageName = (params: any) => post(`${baseUrl}/atomic/packageName/exist`, params); // 检查原子化包名是否存在,存在时返回true,不存在时返回false
const appRepeatPackageName = (params: any) => post(`${baseUrl}/app/packageName/exist`, params); // 检查应用包名是否存在,存在时返回true,不存在时返回false
const engineRepeatPackageName = (params: any) => post(`${baseUrl}/engine/packageName/exist`, params); // 检查开鸿应用引擎包名是否存在，存在时返回true，不存在时返回false
const acsRepeatPackageName = (params: any) => post(`${baseUrl}/acs/packageName/exist`, params); // 检查安卓生态应用包名是否存在，存在时返回true，不存在时返回false
const componentRepeatPackageName = (params: any) => post(`${baseUrl}/component/packageName/exist`, params); // 检查组件包名是否存在，存在时返回true，不存在时返回false
const atomicAdd = (params: any) => post(`${baseUrl}/atomic/create`, params); // 创建原子化
const appAdd = (params: any) => post(`${baseUrl}/app/create`, params); // 创建应用
const engineAdd = (params: any) => post(`${baseUrl}/engine/create`, params); // 开鸿应用引擎创建
const acsAdd = (params: any) => post(`${baseUrl}/acs/create`, params); // 安卓生态应用创建
const componentAdd = (params: any) => post(`${baseUrl}/component/create`, params); // 组件创建
const defaultPrivate = (params: any) => get(`${baseUrl2}/file/default/private/url`, { params }); //默认私有文件下载地址

export default {
  getAtomicPage,
  getAppPage,
  getEnginePage,
  getAcsPage,
  getComponentPage,
  atomicRepeatName,
  appRepeatName,
  engineRepeatName,
  acsRepeatName,
  componentRepeatName,
  atomicRepeatPackageName,
  appRepeatPackageName,
  engineRepeatPackageName,
  acsRepeatPackageName,
  componentRepeatPackageName,
  atomicAdd,
  appAdd,
  engineAdd,
  acsAdd,
  componentAdd,
  defaultPrivate,
};
